module.exports = __webpack_public_path__ + "ca5ac72e988ca5261458cf08e4c33aa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mentor/Son@2x.png
// module id = 104
// module chunks = 0